// Collector Stats — aggregate "how many Aluvo users own this coin" counts.
// Copy and formatting come from @aluvo/constants/src/collectorStats so web and
// mobile say exactly the same thing; this file only lays it out. Counts only,
// never who. `stats == null` (not loaded) renders nothing.
import React from 'react';
import {
    collectionCardCollectorLabel,
    collectionCollectorView,
    mediaCollectorStatsView,
} from '@aluvo/constants/src/collectorStats';
import styles from './CollectorStats.module.css';

/** Movie / TV-season coin panel: total, per-tier counts, one Legendary note. */
export function MediaCollectorStats({ stats, className = '' }) {
    const view = mediaCollectorStatsView(stats);
    if (!view) return null;
    return (
        <section className={`${styles.panel} ${className}`} aria-label="Collector stats" data-testid="media-collector-stats">
            <span className={styles.kicker}>Collector stats</span>
            {view.empty ? (
                <p className={styles.empty}>{view.headline}</p>
            ) : (
                <>
                    <p className={styles.headline}>{view.headline}</p>
                    <dl className={styles.tiers}>
                        {view.tiers.map((tier) => (
                            <div key={tier.key} className={styles.tier}>
                                <dt className={styles.tierLabel}>
                                    <span className={`${styles.dot} ${styles[tier.key]}`} aria-hidden="true" />
                                    {tier.label}
                                </dt>
                                <dd className={tier.count ? styles.tierCount : `${styles.tierCount} ${styles.zero}`}>{tier.display}</dd>
                            </div>
                        ))}
                    </dl>
                    {view.note && <p className={styles.note}>{view.note.title} {view.note.body}</p>}
                </>
            )}
        </section>
    );
}

/** Collection Detail: "43 collectors have earned The Witching Hour" / zero-state copy. */
export function CollectionCollectorStats({ collection, className = '' }) {
    const view = collectionCollectorView(collection);
    if (!view) return null;
    return (
        <p className={`${styles.collectionLine} ${view.empty ? styles.muted : ''} ${className}`} data-testid="collection-collector-stats">
            {view.text}
            {view.rewardName && <> <strong className={styles.rewardName}>{view.rewardName}</strong></>}
        </p>
    );
}

/** Collection card: "43 collectors" · "1 collector" · "Be the first". */
export function CollectionCardCollectors({ collection, className = '' }) {
    const label = collectionCardCollectorLabel(collection);
    if (!label) return null;
    return <span className={`${styles.cardLabel} ${className}`} data-testid="collection-card-collectors">{label}</span>;
}
